import Hls from 'hls.js';

class LightBox extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }

    init() {
        document.body.addEventListener('click', (event) => {
            const openerEl = event.target.closest('[data-lightbox]');
            if (openerEl) {
                this.openerEl = openerEl;
                this.handleOpenerClick(event);
            }
        });

        document.querySelectorAll('[data-close-lightbox]').forEach((el) => {
            el.addEventListener('click', this.handleCloseClick.bind(this));
        });

        this.cta = this.querySelector('.lightbox__cta');
        this.contentContainer = this.querySelector('.lightbox__content-container');
        if (!this.contentContainer)
            throw new Error('Missing content container (.lightbox__content-container)');
    }

    /**
     * Handles the click event on the openerEl element.
     *
     * @param {Event} e - The click event object.
     */
    handleOpenerClick(e) {
        e.preventDefault();
        e.stopPropagation();

        this.contentContainer.innerHTML = '';

        this.showLoadingSpinner();
        this.renderContent();
        this.renderCTA();
        this.open();
    }

    showLoadingSpinner() {
        console.log('showLoadingSpinner');
        this.classList.add('is-loading');
    }

    hideLoadingSpinner() {
        console.log('hideLoadingSpinner');
        this.classList.remove('is-loading');
    }

    renderCTA() {
        const { ctaUrl, ctaText } = this.openerEl.dataset;
        console.log('renderCTA', ctaText, ctaUrl);
        if (ctaUrl && ctaText) {
            console.log('showing lightbox cta');
            this.cta.classList.remove('hidden');
            const textContainer = this.cta.querySelector('.lightbox__cta-text');
            textContainer.innerHTML = ctaText;
            this.cta.setAttribute('href', ctaUrl);
        } else {
            this.cta.classList.add('hidden');
        }
    }

    renderContent(el = this.openerEl) {
        const source = el.getAttribute('data-src');

        console.log('renderContent', source);

        if (!source) {
            this.contentContainer.innerHTML = el.outerHTML;
            return this.hideLoadingSpinner();
        }

        if (el.dataset.lightbox === 'video') {
            const sourceMp4 = el.getAttribute('data-src-mp4');

            this.createVideo(el);
        } else {
            this.createImage(source);
        }
    }

    createImage(source) {
        const img = document.createElement('img');
        img.src = source;

        img.onload = this.hideLoadingSpinner.bind(this);
        img.onerror = this.hideLoadingSpinner.bind(this);
        this.contentContainer.appendChild(img);
    }

    createVideo(el) {
        const { src, srcMp4, width, height } = el.dataset;
        const video = document.createElement('video');
        video.controls = true;
        video.autoplay = true;
        video.muted = false;
        video.width = width;
        video.height = height;
        video.playsInline = true;
        video.setAttribute('playsinline', 'true');

        console.log({ src, srcMp4, width, height });

        if (Hls.isSupported() && src.endsWith('.m3u8')) {
            const hls = new Hls();
            hls.loadSource(src);
            hls.attachMedia(video);
            video.play();

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                this.hideLoadingSpinner();
            });

            hls.on(Hls.Events.ERROR, () => {
                this.hideLoadingSpinner();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = src;
        } else if (srcMp4) {
            video.src = srcMp4;
        } else {
            console.error('Could not load video');
            return this.close();
        }

        video.addEventListener('canplay', () => {
            this.hideLoadingSpinner();
        });

        video.addEventListener('error', this.hideLoadingSpinner.bind(this));

        this.contentContainer.appendChild(video);
    }

    /**
     * Handles the click event on the openerEl element.
     *
     * @param {Event} e - The click event object.
     */
    handleCloseClick(e) {
        e.preventDefault();
        e.stopPropagation();

        this.contentContainer.innerHTML = '';

        this.close();
    }

    open() {
        this.toggleAttribute('open', true);

        this.initialFixedClass = document.body.classList.contains('fixed');
        this.initialOverflowHiddenClass = document.body.classList.contains('overflow-hidden');

        // Prevents page behind from scrolling
        this.scrollY = window.scrollY;
        document.body.classList.add('fixed', 'overflow-hidden');
        document.body.style.top = `-${this.scrollY}px`;
        document.documentElement.style.height = '100vh';
    }

    close() {
        this.toggleAttribute('open', false);

        // Restore page position and scroll behaviour.
        document.documentElement.style.height = '';
        document.body.style.top = '';

        document.body.classList.remove('fixed');

        document.body.classList.remove('overflow-hidden');

        window.scrollTo(0, this.scrollY);

        document.body.setAttribute('tabindex', '-1');
        document.body.focus();

        // Remove the tabindex attribute after a short delay
        setTimeout(() => {
            document.body.removeAttribute('tabindex');
        }, 100);
    }
}

customElements.define('light-box', LightBox);
